import React from 'react';
import FormInput from 'components/forms/bases/FormInput';
import FormTextarea from 'components/forms/bases/FormTextarea'
import withFormLanguages from 'hocs/bases/withFormLanguages'

const langText = {
  en: 'English',
  th: 'ไทย',
}

const EnhanceFormInput = withFormLanguages()(FormInput)
const EnhancedFormTextarea = withFormLanguages()(FormTextarea)

const FormLanguage = (props) => (
  <EnhanceFormInput
    {...props}
    createPropsByLang={(lang) => ({ hintText: langText[lang] })}
  />
)

FormLanguage.Textarea = (props) => (
  <EnhancedFormTextarea
    {...props}
    createPropsByLang={(lang) => ({ hintText: langText[lang] })}
  />
)


export default FormLanguage;



// WEBPACK FOOTER //
// ./src/components/forms/FormLanguage.js